import { render } from "./FormSuccessful.vue?vue&type=template&id=608e9c63&scoped=true"
import script from "./FormSuccessful.vue?vue&type=script&lang=js"
export * from "./FormSuccessful.vue?vue&type=script&lang=js"

import "./FormSuccessful.vue?vue&type=style&index=0&id=608e9c63&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608e9c63"]])

export default __exports__